import z from "zod";

const buildDataSchema = z.object({
    version: z.string(),
    codename: z.string(),
});

export { buildDataSchema };
